/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} License_Error_GenericInputs */



/**
* | output |
* | --- |
* | "Something went wrong. Try again, or contact support@closedcaptioncreator.com." |
*
* @param {License_Error_GenericInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const license_error_generic = /** @type {((inputs?: License_Error_GenericInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<License_Error_GenericInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Une erreur s'est produite. Réessayez ou contactez support@closedcaptioncreator.com.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Etwas ist schiefgelaufen. Versuchen Sie es erneut oder wenden Sie sich an support@closedcaptioncreator.com.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Si è verificato un problema. Riprova o contatta support@closedcaptioncreator.com.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Что-то пошло не так. Повторите попытку или напишите на support@closedcaptioncreator.com.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Algo salió mal. Inténtalo de nuevo o escribe a support@closedcaptioncreator.com.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("出现问题。请重试，或联系 support@closedcaptioncreator.com。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("問題が発生しました。再試行するか、support@closedcaptioncreator.com までお問い合わせください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कुछ गलत हो गया। फिर से कोशिश करें या support@closedcaptioncreator.com से संपर्क करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ocorreu um erro. Tente novamente ou contacte support@closedcaptioncreator.com.")
	return /** @type {LocalizedString} */ ("Something went wrong. Try again, or contact support@closedcaptioncreator.com.")
});